import { Button } from '@/components/ui/button';
import { Eye, Edit, Trash2, RotateCcw } from 'lucide-react';

export const UniversalCrudActions = ({
  entityLabel,
  entityId,
  isDeleted = false,
  canView = true,
  canEdit = true,
  canDelete = true,
  canRecover = true,
  onView,
  onEdit,
  onDelete,
  onRecover,
  extraActions = null,
  align = 'end',
  compact = false,
}) => {
  const justifyClass = align === 'center' ? 'justify-center' : 'justify-end';
  const buttonSize = compact ? 'icon' : 'sm';
  const baseButtonClass = compact ? 'h-8 w-8 rounded-lg px-0' : 'h-8 rounded-lg px-2.5';

  return (
    <div className={`flex flex-nowrap items-center gap-1 ${justifyClass}`} data-testid={`${entityLabel}-crud-actions-${entityId}`}>
      {canView && onView && (
        <Button
          variant="outline"
          size={buttonSize}
          onClick={onView}
          title="Visualizar"
          className={baseButtonClass}
          data-testid={`view-${entityLabel}-${entityId}`}
        >
          <Eye className={compact ? 'h-4 w-4' : 'mr-1.5 h-4 w-4'} />
          {!compact && 'Ver'}
        </Button>
      )}

      {!isDeleted && canEdit && onEdit && (
        <Button
          variant="outline"
          size={buttonSize}
          onClick={onEdit}
          title="Editar"
          className={`${baseButtonClass} border-amber-200 text-amber-700 hover:bg-amber-50`}
          data-testid={`edit-${entityLabel}-${entityId}`}
        >
          <Edit className={compact ? 'h-4 w-4' : 'mr-1.5 h-4 w-4'} />
          {!compact && 'Editar'}
        </Button>
      )}

      {!isDeleted && canDelete && onDelete && (
        <Button
          variant="outline"
          size={buttonSize}
          onClick={onDelete}
          title="Apagar"
          className={`${baseButtonClass} border-red-200 text-red-600 hover:bg-red-50`}
          data-testid={`delete-${entityLabel}-${entityId}`}
        >
          <Trash2 className={compact ? 'h-4 w-4' : 'mr-1.5 h-4 w-4'} />
          {!compact && 'Apagar'}
        </Button>
      )}

      {isDeleted && canRecover && onRecover && (
        <Button
          variant="outline"
          size={buttonSize}
          onClick={onRecover}
          title="Recuperar"
          className={`${baseButtonClass} border-green-200 text-green-600 hover:bg-green-50`}
          data-testid={`recover-${entityLabel}-${entityId}`}
        >
          <RotateCcw className={compact ? 'h-4 w-4' : 'mr-1.5 h-4 w-4'} />
          {!compact && 'Recuperar'}
        </Button>
      )}

      {extraActions}
    </div>
  );
};
